import { useState } from 'react';

const useOnboardingStepCounter = () => {
  const [step, setStep] = useState<number>();

  const dismiss = () => setStep(undefined);
  const incrementStep = () => setStep((prevStep) => {
    if (prevStep !== undefined) return prevStep + 1;
    return;
  });
  const decrementStep = () => setStep((prevStep) => {
    if (prevStep !== undefined) return prevStep - 1;
    return;
  });
  const startOnboarding = () => {
    setStep(1);
  };

  return { step, startOnboarding, incrementStep, decrementStep, dismiss };
};

export default useOnboardingStepCounter;
